var _polygon, _polygon2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlocks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fence--inject-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--fence--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "452.54 337.39 452.54 271.11 448.06 261.86 443.48 265.9 443.48 332.18 452.54 337.39",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.54 337.39 452.54 271.11 448.06 261.86 443.48 265.9 443.48 332.18 452.54 337.39",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.54 271.11 454.81 269.8 454.81 336.08 452.54 337.39 452.54 271.11",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.54 271.11 454.81 269.8 454.81 336.08 452.54 337.39 452.54 271.11",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "448.06 261.86 450.32 260.51 454.81 269.8 452.54 271.11 448.06 261.86",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.05 318.13 419.05 251.85 414.56 242.61 409.98 246.64 409.98 312.93 419.05 318.13",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.05 318.13 419.05 251.85 414.56 242.61 409.98 246.64 409.98 312.93 419.05 318.13",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.05 251.85 421.31 250.55 421.31 316.83 419.05 318.13 419.05 251.85",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.05 251.85 421.31 250.55 421.31 316.83 419.05 318.13 419.05 251.85",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.56 242.61 416.83 241.26 421.31 250.55 419.05 251.85 414.56 242.61",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.55 298.88 385.55 232.6 381.07 223.36 376.49 227.39 376.49 293.67 385.55 298.88",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.55 298.88 385.55 232.6 381.07 223.36 376.49 227.39 376.49 293.67 385.55 298.88",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.55 232.6 387.82 231.3 387.82 297.58 385.55 298.88 385.55 232.6",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.55 232.6 387.82 231.3 387.82 297.58 385.55 298.88 385.55 232.6",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.07 223.36 383.33 222.01 387.82 231.3 385.55 232.6 381.07 223.36",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.06 279.63 352.06 213.35 347.57 204.11 342.99 208.14 342.99 274.42 352.06 279.63",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.06 279.63 352.06 213.35 347.57 204.11 342.99 208.14 342.99 274.42 352.06 279.63",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.06 213.35 354.32 212.05 354.32 278.33 352.06 279.63 352.06 213.35",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.06 213.35 354.32 212.05 354.32 278.33 352.06 279.63 352.06 213.35",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.57 204.11 349.84 202.76 354.32 212.05 352.06 213.35 347.57 204.11",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.56 260.38 318.56 194.1 314.07 184.86 309.5 188.89 309.5 255.17 318.56 260.38",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.56 260.38 318.56 194.1 314.07 184.86 309.5 188.89 309.5 255.17 318.56 260.38",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.56 194.1 320.83 192.8 320.83 259.08 318.56 260.38 318.56 194.1",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.56 194.1 320.83 192.8 320.83 259.08 318.56 260.38 318.56 194.1",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.07 184.86 316.34 183.5 320.83 192.8 318.56 194.1 314.07 184.86",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.8 318.2 299.89 224.6 299.89 228.16 462.8 321.76 462.8 318.2",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.8 318.2 299.89 224.6 299.89 228.16 462.8 321.76 462.8 318.2",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.8 318.2 465.13 316.86 465.13 320.42 462.8 321.76 462.8 318.2",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.8 318.2 465.13 316.86 465.13 320.42 462.8 321.76 462.8 318.2",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.89 224.6 462.8 318.2 465.13 316.86 302.23 223.25 299.89 224.6",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.8 295.38 299.89 201.79 299.89 205.35 462.8 298.95 462.8 295.38",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.8 295.38 299.89 201.79 299.89 205.35 462.8 298.95 462.8 295.38",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.8 295.38 465.13 294.05 465.13 297.61 462.8 298.95 462.8 295.38",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.8 295.38 465.13 294.05 465.13 297.61 462.8 298.95 462.8 295.38",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.89 201.79 462.8 295.38 465.13 294.05 302.23 200.44 299.89 201.79",
    style: {
      fill: "#900000"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shed--inject-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shed--inject-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shed--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 374.04 99.56 361.21 199.55 418.93 199.55 431.76 99.56 374.04",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 374.04 99.56 361.21 199.55 418.93 199.55 431.76 99.56 374.04",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 431.76 203.25 429.62 203.25 416.79 199.55 418.93 199.55 431.76",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 431.76 203.25 429.62 203.25 416.79 199.55 418.93 199.55 431.76",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 361.21 103.27 359.07 203.25 416.79 199.55 418.93 99.56 361.21",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 361.21 103.27 359.07 203.25 416.79 199.55 418.93 99.56 361.21",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 359.07 99.56 346.24 199.55 403.97 199.55 416.79 99.56 359.07",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 359.07 99.56 346.24 199.55 403.97 199.55 416.79 99.56 359.07",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 416.79 203.25 414.66 203.25 401.83 199.55 403.97 199.55 416.79",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 416.79 203.25 414.66 203.25 401.83 199.55 403.97 199.55 416.79",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 346.24 103.27 344.1 203.25 401.83 199.55 403.97 99.56 346.24",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 346.24 103.27 344.1 203.25 401.83 199.55 403.97 99.56 346.24",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 344.1 99.56 331.27 199.55 389 199.55 401.83 99.56 344.1",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 344.1 99.56 331.27 199.55 389 199.55 401.83 99.56 344.1",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 401.83 203.25 399.69 203.25 386.86 199.55 389 199.55 401.83",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 401.83 203.25 399.69 203.25 386.86 199.55 389 199.55 401.83",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 331.27 103.27 329.14 203.25 386.86 199.55 389 99.56 331.27",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 331.27 103.27 329.14 203.25 386.86 199.55 389 99.56 331.27",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 329.14 99.56 316.31 199.55 374.03 199.55 386.86 99.56 329.14",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 329.14 99.56 316.31 199.55 374.03 199.55 386.86 99.56 329.14",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 386.86 203.25 384.72 203.25 371.9 199.55 374.03 199.55 386.86",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 386.86 203.25 384.72 203.25 371.9 199.55 374.03 199.55 386.86",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 316.31 103.27 314.17 203.25 371.9 199.55 374.03 99.56 316.31",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 316.31 103.27 314.17 203.25 371.9 199.55 374.03 99.56 316.31",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 314.17 99.56 301.34 199.55 359.07 199.55 371.9 99.56 314.17",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 314.17 99.56 301.34 199.55 359.07 199.55 371.9 99.56 314.17",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 371.9 203.25 369.76 203.25 356.93 199.55 359.07 199.55 371.9",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 371.9 203.25 369.76 203.25 356.93 199.55 359.07 199.55 371.9",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 301.34 103.27 299.2 203.25 356.93 199.55 359.07 99.56 301.34",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 301.34 103.27 299.2 203.25 356.93 199.55 359.07 99.56 301.34",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 299.2 99.56 286.38 199.55 344.1 199.55 356.93 99.56 299.2",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 299.2 99.56 286.38 199.55 344.1 199.55 356.93 99.56 299.2",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 356.93 203.25 354.79 203.25 341.96 199.55 344.1 199.55 356.93",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 356.93 203.25 354.79 203.25 341.96 199.55 344.1 199.55 356.93",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 286.38 103.27 284.24 203.25 341.96 199.55 344.1 99.56 286.38",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 286.38 103.27 284.24 203.25 341.96 199.55 344.1 99.56 286.38",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 284.24 99.56 271.41 199.55 329.14 199.55 341.96 99.56 284.24",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 284.24 99.56 271.41 199.55 329.14 199.55 341.96 99.56 284.24",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 341.96 203.25 339.83 203.25 327 199.55 329.14 199.55 341.96",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 341.96 203.25 339.83 203.25 327 199.55 329.14 199.55 341.96",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 271.41 103.27 269.27 203.25 327 199.55 329.14 99.56 271.41",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 271.41 103.27 269.27 203.25 327 199.55 329.14 99.56 271.41",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 269.27 99.56 256.44 199.55 314.17 199.55 327 99.56 269.27",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 269.27 99.56 256.44 199.55 314.17 199.55 327 99.56 269.27",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 327 203.25 324.86 203.25 312.03 199.55 314.17 199.55 327",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 327 203.25 324.86 203.25 312.03 199.55 314.17 199.55 327",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 256.44 103.27 254.31 203.25 312.03 199.55 314.17 99.56 256.44",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 256.44 103.27 254.31 203.25 312.03 199.55 314.17 99.56 256.44",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 254.31 99.56 241.48 199.55 299.2 199.55 312.03 99.56 254.31",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 254.31 99.56 241.48 199.55 299.2 199.55 312.03 99.56 254.31",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 312.03 203.25 309.89 203.25 297.07 199.55 299.2 199.55 312.03",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 312.03 203.25 309.89 203.25 297.07 199.55 299.2 199.55 312.03",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 241.48 103.27 239.34 203.25 297.07 199.55 299.2 99.56 241.48",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 241.48 103.27 239.34 203.25 297.07 199.55 299.2 99.56 241.48",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 239.34 99.56 226.51 199.55 284.24 199.55 297.07 99.56 239.34",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 239.34 99.56 226.51 199.55 284.24 199.55 297.07 99.56 239.34",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 297.07 203.25 294.93 203.25 282.1 199.55 284.24 199.55 297.07",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 297.07 203.25 294.93 203.25 282.1 199.55 284.24 199.55 297.07",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 226.51 103.27 224.38 203.25 282.1 199.55 284.24 99.56 226.51",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 226.51 103.27 224.38 203.25 282.1 199.55 284.24 99.56 226.51",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 224.38 99.56 211.55 199.55 269.27 199.55 282.1 99.56 224.38",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 224.38 99.56 211.55 199.55 269.27 199.55 282.1 99.56 224.38",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 282.1 203.25 279.96 203.25 267.13 199.55 269.27 199.55 282.1",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 282.1 203.25 279.96 203.25 267.13 199.55 269.27 199.55 282.1",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 211.55 103.27 209.41 203.25 267.13 199.55 269.27 99.56 211.55",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 211.55 103.27 209.41 203.25 267.13 199.55 269.27 99.56 211.55",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 209.41 99.56 196.58 199.55 254.31 199.55 267.13 99.56 209.41",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 209.41 99.56 196.58 199.55 254.31 199.55 267.13 99.56 209.41",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 267.13 203.25 265 203.25 252.17 199.55 254.31 199.55 267.13",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 267.13 203.25 265 203.25 252.17 199.55 254.31 199.55 267.13",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 196.58 103.27 194.44 203.25 252.17 199.55 254.31 99.56 196.58",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 196.58 103.27 194.44 203.25 252.17 199.55 254.31 99.56 196.58",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 194.44 99.56 181.62 199.55 239.34 199.55 252.17 99.56 194.44",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 194.44 99.56 181.62 199.55 239.34 199.55 252.17 99.56 194.44",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 252.17 203.25 250.03 203.25 237.2 199.55 239.34 199.55 252.17",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 252.17 203.25 250.03 203.25 237.2 199.55 239.34 199.55 252.17",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 181.62 103.27 179.48 203.25 237.2 199.55 239.34 99.56 181.62",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 181.62 103.27 179.48 203.25 237.2 199.55 239.34 99.56 181.62",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 179.48 99.56 166.65 199.55 224.38 199.55 237.21 99.56 179.48",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 179.48 99.56 166.65 199.55 224.38 199.55 237.21 99.56 179.48",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 237.21 203.25 235.07 203.25 222.24 199.55 224.38 199.55 237.21",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.55 237.21 203.25 235.07 203.25 222.24 199.55 224.38 199.55 237.21",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 166.65 103.27 164.52 203.25 222.24 199.55 224.38 99.56 166.65",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 166.65 103.27 164.52 203.25 222.24 199.55 224.38 99.56 166.65",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 335.56 373.59 322.73 203.25 421.07 203.25 433.9 373.59 335.56",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 335.56 373.59 322.73 203.25 421.07 203.25 433.9 373.59 335.56",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 433.9 199.55 431.76 199.55 418.93 203.25 421.07 203.25 433.9",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 433.9 199.55 431.76 199.55 418.93 203.25 421.07 203.25 433.9",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 322.73 369.89 320.59 199.55 418.93 203.25 421.07 373.59 322.73",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 322.73 369.89 320.59 199.55 418.93 203.25 421.07 373.59 322.73",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 320.59 373.59 307.76 203.25 406.11 203.25 418.93 373.59 320.59",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 320.59 373.59 307.76 203.25 406.11 203.25 418.93 373.59 320.59",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 418.93 199.55 416.8 199.55 403.97 203.25 406.11 203.25 418.93",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 418.93 199.55 416.8 199.55 403.97 203.25 406.11 203.25 418.93",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 307.76 369.89 305.62 199.55 403.97 203.25 406.11 373.59 307.76",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 307.76 369.89 305.62 199.55 403.97 203.25 406.11 373.59 307.76",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 305.62 373.59 292.8 203.25 391.14 203.25 403.97 373.59 305.62",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 305.62 373.59 292.8 203.25 391.14 203.25 403.97 373.59 305.62",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 403.97 199.55 401.83 199.55 389 203.25 391.14 203.25 403.97",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 403.97 199.55 401.83 199.55 389 203.25 391.14 203.25 403.97",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 292.8 369.89 290.66 199.55 389 203.25 391.14 373.59 292.8",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 292.8 369.89 290.66 199.55 389 203.25 391.14 373.59 292.8",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 290.66 373.59 277.83 203.25 376.17 203.25 389 373.59 290.66",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 290.66 373.59 277.83 203.25 376.17 203.25 389 373.59 290.66",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 389 199.55 386.86 199.55 374.04 203.25 376.17 203.25 389",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 389 199.55 386.86 199.55 374.04 203.25 376.17 203.25 389",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 277.83 369.89 275.69 199.55 374.04 203.25 376.17 373.59 277.83",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 277.83 369.89 275.69 199.55 374.04 203.25 376.17 373.59 277.83",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 275.69 373.59 262.86 203.25 361.21 203.25 374.04 373.59 275.69",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 275.69 373.59 262.86 203.25 361.21 203.25 374.04 373.59 275.69",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 374.04 199.55 371.9 199.55 359.07 203.25 361.21 203.25 374.04",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 374.04 199.55 371.9 199.55 359.07 203.25 361.21 203.25 374.04",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 262.86 369.89 260.73 199.55 359.07 203.25 361.21 373.59 262.86",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 262.86 369.89 260.73 199.55 359.07 203.25 361.21 373.59 262.86",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 260.73 373.59 247.9 203.25 346.24 203.25 359.07 373.59 260.73",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 260.73 373.59 247.9 203.25 346.24 203.25 359.07 373.59 260.73",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 359.07 199.55 356.93 199.55 344.1 203.25 346.24 203.25 359.07",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 359.07 199.55 356.93 199.55 344.1 203.25 346.24 203.25 359.07",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 247.9 369.89 245.76 199.55 344.1 203.25 346.24 373.59 247.9",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 247.9 369.89 245.76 199.55 344.1 203.25 346.24 373.59 247.9",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 245.76 373.59 232.93 203.25 331.27 203.25 344.1 373.59 245.76",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 245.76 373.59 232.93 203.25 331.27 203.25 344.1 373.59 245.76",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 344.1 199.55 341.96 199.55 329.14 203.25 331.27 203.25 344.1",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 344.1 199.55 341.96 199.55 329.14 203.25 331.27 203.25 344.1",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 232.93 369.89 230.79 199.55 329.14 203.25 331.27 373.59 232.93",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 232.93 369.89 230.79 199.55 329.14 203.25 331.27 373.59 232.93",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 230.79 373.59 217.97 203.25 316.31 203.25 329.14 373.59 230.79",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 230.79 373.59 217.97 203.25 316.31 203.25 329.14 373.59 230.79",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 329.14 199.55 327 199.55 314.17 203.25 316.31 203.25 329.14",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 329.14 199.55 327 199.55 314.17 203.25 316.31 203.25 329.14",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 217.97 369.89 215.83 199.55 314.17 203.25 316.31 373.59 217.97",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 217.97 369.89 215.83 199.55 314.17 203.25 316.31 373.59 217.97",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 215.83 373.59 203 203.25 301.34 203.25 314.17 373.59 215.83",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 215.83 373.59 203 203.25 301.34 203.25 314.17 373.59 215.83",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 314.17 199.55 312.03 199.55 299.2 203.25 301.34 203.25 314.17",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 314.17 199.55 312.03 199.55 299.2 203.25 301.34 203.25 314.17",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 203 369.89 200.86 199.55 299.2 203.25 301.34 373.59 203",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 203 369.89 200.86 199.55 299.2 203.25 301.34 373.59 203",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 200.86 373.59 188.03 203.25 286.38 203.25 299.2 373.59 200.86",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 200.86 373.59 188.03 203.25 286.38 203.25 299.2 373.59 200.86",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 299.2 199.55 297.07 199.55 284.24 203.25 286.38 203.25 299.2",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 299.2 199.55 297.07 199.55 284.24 203.25 286.38 203.25 299.2",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 188.03 369.89 185.9 199.55 284.24 203.25 286.38 373.59 188.03",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 188.03 369.89 185.9 199.55 284.24 203.25 286.38 373.59 188.03",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 185.9 373.59 173.07 203.25 271.41 203.25 284.24 373.59 185.9",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 185.9 373.59 173.07 203.25 271.41 203.25 284.24 373.59 185.9",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 284.24 199.55 282.1 199.55 269.27 203.25 271.41 203.25 284.24",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 284.24 199.55 282.1 199.55 269.27 203.25 271.41 203.25 284.24",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 173.07 369.89 170.93 199.55 269.27 203.25 271.41 373.59 173.07",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 173.07 369.89 170.93 199.55 269.27 203.25 271.41 373.59 173.07",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 170.93 373.59 158.1 203.25 256.44 203.25 269.27 373.59 170.93",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 170.93 373.59 158.1 203.25 256.44 203.25 269.27 373.59 170.93",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 269.27 199.55 267.13 199.55 254.31 203.25 256.44 203.25 269.27",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 269.27 199.55 267.13 199.55 254.31 203.25 256.44 203.25 269.27",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 158.1 369.89 155.96 199.55 254.31 203.25 256.44 373.59 158.1",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 158.1 369.89 155.96 199.55 254.31 203.25 256.44 373.59 158.1",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 155.96 373.59 143.13 203.25 241.48 203.25 254.31 373.59 155.96",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 155.96 373.59 143.13 203.25 241.48 203.25 254.31 373.59 155.96",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 254.31 199.55 252.17 199.55 239.34 203.25 241.48 203.25 254.31",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 254.31 199.55 252.17 199.55 239.34 203.25 241.48 203.25 254.31",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 143.13 369.89 141 199.55 239.34 203.25 241.48 373.59 143.13",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.59 143.13 369.89 141 199.55 239.34 203.25 241.48 373.59 143.13",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.89 145.27 373.59 143.13 373.59 335.56 369.89 337.69 369.89 145.27",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 241.48 206.95 239.34 206.95 431.76 203.25 433.9 203.25 241.48",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 241.48 199.55 239.34 199.55 431.76 203.25 433.9 203.25 241.48",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.27 168.79 99.56 166.65 99.56 374.04 103.27 376.17 103.27 168.79",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Door--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "343.52 191.44 343.52 349.32 227.18 416.48 227.18 258.6 343.52 191.44",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.52 191.44 343.52 349.32 227.18 416.48 227.18 258.6 343.52 191.44",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.52 191.44 271.77 232.87 271.77 278.76 343.52 320.18 343.52 191.44",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.77 249.06 343.52 207.64 343.52 191.44 271.77 232.87 271.77 249.06",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.66 239.43 270.66 393.77 283.99 386.07 283.99 231.73 270.66 239.43",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.99 230 283.99 231.73 270.66 239.43 267.65 237.69 280.99 230",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.66 239.43 267.65 237.69 267.57 391.98 270.66 393.77 270.66 239.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.55 247.57 256.55 401.91 269.89 394.21 269.89 239.87 256.55 247.57",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.88 238.14 269.89 239.87 256.55 247.57 253.55 245.84 266.88 238.14",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.55 247.57 253.55 245.84 253.47 400.12 256.55 401.91 256.55 247.57",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.45 255.71 242.45 410.05 255.78 402.36 255.78 248.02 242.45 255.71",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.77 246.28 255.78 248.02 242.45 255.71 239.44 253.98 252.77 246.28",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.45 255.71 239.44 253.98 239.36 408.26 242.45 410.05 242.45 255.71",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.34 263.86 228.34 418.19 241.67 410.5 241.67 256.16 228.34 263.86",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.67 254.42 241.67 256.16 228.34 263.86 225.33 262.12 238.67 254.42",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.34 263.86 225.33 262.12 225.25 416.41 228.34 418.19 228.34 263.86",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.3 282.47 228.34 285.92 228.34 293.84 234.3 290.4 238.04 284.28 234.3 282.47",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.1,286.55a1.63,1.63,0,0,1-.69,1.32c-.38.22-.69,0-.69-.52a1.66,1.66,0,0,1,.69-1.32C233.8,285.81,234.1,286,234.1,286.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.3 317.19 228.34 320.63 228.34 328.56 234.3 325.12 238.04 318.99 234.3 317.19",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.1,321.27a1.62,1.62,0,0,1-.69,1.31c-.38.22-.69,0-.69-.52a1.66,1.66,0,0,1,.69-1.32C233.8,320.52,234.1,320.76,234.1,321.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.3 351.91 228.34 355.35 228.34 363.27 234.3 359.83 238.04 353.71 234.3 351.91",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.1,356a1.63,1.63,0,0,1-.69,1.32c-.38.22-.69,0-.69-.52a1.66,1.66,0,0,1,.69-1.32C233.8,355.24,234.1,355.47,234.1,356Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.3 386.62 228.34 390.06 228.34 397.99 234.3 394.55 238.04 388.43 234.3 386.62",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.1,390.7a1.63,1.63,0,0,1-.69,1.32c-.38.22-.69,0-.69-.53a1.65,1.65,0,0,1,.69-1.31C233.8,390,234.1,390.19,234.1,390.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.99 231.73 283.99 241.94 228.34 274.08 228.34 263.86 283.99 231.73",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.67 352.25 346.7 353.41 346.7 193.2 344.67 194.37 344.67 352.25",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.7 353.41 354.73 348.77 354.73 179.31 220.3 256.9 220.3 426.36 228.34 421.72 228.34 261.54 346.7 193.2 346.7 353.41",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.73 179.31 220.3 256.9 218.31 255.74 352.74 178.15 354.73 179.31",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.3 426.36 220.3 256.9 218.31 255.74 218.31 425.21 220.3 426.36",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--door--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "354.99 203.81 354.99 358.14 341.66 350.45 341.66 196.11 354.99 203.81",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.67 194.37 341.66 196.11 354.99 203.81 358 202.07 344.67 194.37",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.99 203.81 358 202.07 358.08 356.36 354.99 358.14 354.99 203.81",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.1 211.95 369.1 366.29 355.77 358.59 355.77 204.25 369.1 211.95",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.77 202.51 355.77 204.25 369.1 211.95 372.11 210.21 358.77 202.51",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.1 211.95 372.11 210.21 372.19 364.5 369.1 366.29 369.1 211.95",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.2 220.09 383.2 374.43 369.87 366.73 369.87 212.39 383.2 220.09",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.88 210.66 369.87 212.39 383.2 220.09 386.21 218.35 372.88 210.66",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.2 220.09 386.21 218.35 386.29 372.64 383.2 374.43 383.2 220.09",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.31 228.23 397.31 382.57 383.98 374.87 383.98 220.53 397.31 228.23",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.99 218.8 383.98 220.53 397.31 228.23 400.32 226.5 386.99 218.8",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.31 228.23 400.32 226.5 400.4 380.78 397.31 382.57 397.31 228.23",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.66 196.11 341.66 206.32 397.32 238.45 397.31 228.23 341.66 196.11",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "394.32 377.41 392.75 378.35 343 349.65 344.57 348.71 394.32 377.41",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,351.36l55.68,32.12V229.15L340,197Zm3-149.2,49.74,28.7V378.35L343,349.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.27,197.42l55.22,31.86V383.09l-55.23-31.86V197.42M393,378.74v-148l-.11-.07L343.12,202l-.34-.2v148l.12.07,49.75,28.69.34.2M340,197V351.36l55.68,32.12V229.15L340,197Zm52.71,181.33L343,349.65V202.16l49.74,28.7V378.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343 349.65 344.57 348.71 344.58 203.08 343.01 202.16 343 349.65",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.04 197.02 341.63 196.11 397.32 228.23 395.72 229.15 340.04 197.02",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.32 228.23 395.72 229.15 395.71 383.48 397.31 382.57 397.32 228.23",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.75 300.91 392.75 302.75 343.01 273.89 344.58 272.96 392.75 300.91",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.01 273.89 343 277.31 392.79 306.21 392.79 302.79 343.01 273.89",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.23,274.29l49.33,28.63v2.89l-49.33-28.63v-2.89m-.22-.39v3.41l49.79,28.9v-3.42L343,273.9Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "343.01 202.16 387.06 299.47 392.79 302.79 348.81 205.51 343.01 202.16",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.51,202.71l5.12,3,43.65,96.56-5-2.92-43.73-96.6m-.5-.55,44.05,97.31,5.73,3.32-44-97.28-5.8-3.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.75 299.6 351.07 206.81 348.81 205.51 392.79 302.79 392.75 299.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.01 277.32 387.06 375.06 392.75 378.38 348.81 280.67 343.01 277.32",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.5,277.87l5.13,3,43.62,97-5-2.93-43.74-97m-.49-.55,44.05,97.74,5.69,3.32-43.94-97.71-5.8-3.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.75 375.2 351.07 281.97 348.81 280.67 392.75 378.38 392.75 375.2",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "130.42 282.74 168.67 304.82 168.67 255.78 130.42 233.72 130.42 282.74",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.24 305.73 168.67 306.67 128.85 283.68 130.42 282.74 170.24 305.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.88,285.39l45.75,26.42V254.07l-45.75-26.41Zm3-52.6,39.82,23v50.89l-39.82-23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.85 283.68 130.42 282.74 130.42 233.72 128.85 232.79 128.85 283.68",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.88 227.66 127.48 226.74 173.23 253.16 171.63 254.07 125.88 227.66",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.23 253.16 171.63 254.07 171.63 311.81 173.23 310.89 173.23 253.16",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.36 277.79 167.36 279.63 128.85 257.34 130.42 256.4 167.36 277.79",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.29 245.76 149.69 244.84 149.69 295.73 151.29 294.81 151.29 245.76",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.72 243.13 149.69 244.84 149.69 295.73 146.72 294.01 146.72 243.13",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.85 257.34 128.85 260.76 168.7 283.94 168.7 280.52 128.85 257.34",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.69 269.46 151.29 268.48 168.67 278.54 168.67 280.52 149.69 269.46",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M209.76,245.68c.6-1.27,1.2-2.53,1.79-3.52a5.81,5.81,0,0,1,1.8-2.06,1.76,1.76,0,0,1,1.79,0,8.7,8.7,0,0,1,1.79,1.45,8.77,8.77,0,0,0,1.79,1.45,1.77,1.77,0,0,0,1.79,0,5.7,5.7,0,0,0,1.79-2.06c.6-1,1.2-2.26,1.79-3.52s1.2-2.52,1.8-3.52a5.79,5.79,0,0,1,1.79-2.06,1.76,1.76,0,0,1,1.79,0,8.38,8.38,0,0,1,1.79,1.44,8.14,8.14,0,0,0,1.79,1.45,1.76,1.76,0,0,0,1.79,0,5.75,5.75,0,0,0,1.79-2.07c.6-1,1.2-2.25,1.8-3.51s1.19-2.53,1.79-3.52a5.7,5.7,0,0,1,1.79-2.06,1.77,1.77,0,0,1,1.79,0,8.77,8.77,0,0,1,1.79,1.45,8.7,8.7,0,0,0,1.79,1.45,1.76,1.76,0,0,0,1.79,0,5.81,5.81,0,0,0,1.8-2.06c.59-1,1.19-2.25,1.79-3.52a39.28,39.28,0,0,1,1.79-3.51,5.85,5.85,0,0,1,1.79-2.07,1.77,1.77,0,0,1,1.79,0,7.92,7.92,0,0,1,1.79,1.45,8.42,8.42,0,0,0,1.8,1.44,1.76,1.76,0,0,0,1.79,0,6,6,0,0,0,1.79-2.06c.6-1,1.19-2.26,1.79-3.52s1.19-2.53,1.79-3.52a5.9,5.9,0,0,1,1.79-2.06,1.77,1.77,0,0,1,1.79,0,8.81,8.81,0,0,1,1.8,1.45,8.2,8.2,0,0,0,1.79,1.45,1.77,1.77,0,0,0,1.79,0,5.71,5.71,0,0,0,1.79-2.06c.6-1,1.19-2.25,1.79-3.52s1.2-2.52,1.79-3.51a6,6,0,0,1,1.79-2.07,1.78,1.78,0,0,1,1.8,0,8.38,8.38,0,0,1,1.79,1.45,8.51,8.51,0,0,0,1.79,1.45,1.77,1.77,0,0,0,1.79,0,5.8,5.8,0,0,0,1.79-2.06c.6-1,1.2-2.26,1.79-3.52s1.2-2.52,1.79-3.52a5.81,5.81,0,0,1,1.8-2.06,1.76,1.76,0,0,1,1.79,0,9,9,0,0,1,1.79,1.45,8.14,8.14,0,0,0,1.79,1.45,1.77,1.77,0,0,0,1.79,0,5.75,5.75,0,0,0,1.79-2.07,39.28,39.28,0,0,0,1.79-3.51c.6-1.27,1.2-2.53,1.8-3.52a5.62,5.62,0,0,1,1.79-2.06,1.76,1.76,0,0,1,1.79,0,8.44,8.44,0,0,1,1.79,1.45,8.77,8.77,0,0,0,1.79,1.45,1.76,1.76,0,0,0,1.79,0,5.7,5.7,0,0,0,1.79-2.06c.6-1,1.2-2.26,1.8-3.52s1.19-2.52,1.79-3.52A5.79,5.79,0,0,1,328,173.9a1.77,1.77,0,0,1,1.79,0,8.38,8.38,0,0,1,1.79,1.44,8.38,8.38,0,0,0,1.79,1.45,1.76,1.76,0,0,0,1.79,0,5.86,5.86,0,0,0,1.8-2.07c.59-1,1.19-2.25,1.79-3.51a38.21,38.21,0,0,1,1.79-3.52,5.8,5.8,0,0,1,1.79-2.06,1.77,1.77,0,0,1,1.79,0,8.2,8.2,0,0,1,1.79,1.45,9,9,0,0,0,1.79,1.45,1.78,1.78,0,0,0,1.8,0,5.9,5.9,0,0,0,1.79-2.06c.59-1,1.19-2.26,1.79-3.52s1.19-2.52,1.79-3.51a5.85,5.85,0,0,1,1.79-2.07,1.76,1.76,0,0,1,1.79,0,7.92,7.92,0,0,1,1.79,1.45,8.42,8.42,0,0,0,1.8,1.44,1.76,1.76,0,0,0,1.79,0,6,6,0,0,0,1.79-2.06c.6-1,1.19-2.26,1.79-3.52s1.19-2.53,1.79-3.52a5.9,5.9,0,0,1,1.79-2.06,1.77,1.77,0,0,1,1.79,0,8.81,8.81,0,0,1,1.8,1.45,8.2,8.2,0,0,0,1.79,1.45,1.77,1.77,0,0,0,1.79,0A5.8,5.8,0,0,0,380,149.9a38.21,38.21,0,0,0,1.79-3.52c.6-1.26,1.2-2.52,1.79-3.51a5.86,5.86,0,0,1,1.8-2.07,1.76,1.76,0,0,1,1.79,0,2.9,2.9,0,0,1,.33.2L269.06,59.83a3,3,0,0,0-.44-.28,1.76,1.76,0,0,0-1.79,0,5.81,5.81,0,0,0-1.8,2.06c-.59,1-1.19,2.26-1.79,3.52s-1.19,2.52-1.79,3.52a5.89,5.89,0,0,1-1.79,2.06,1.79,1.79,0,0,1-1.79,0,8.51,8.51,0,0,1-1.79-1.45,8.38,8.38,0,0,0-1.79-1.45,1.78,1.78,0,0,0-1.8,0,6,6,0,0,0-1.79,2.07c-.59,1-1.19,2.25-1.79,3.51s-1.19,2.53-1.79,3.52A5.8,5.8,0,0,1,245.33,79a1.77,1.77,0,0,1-1.79,0,8.2,8.2,0,0,1-1.79-1.45A8.81,8.81,0,0,0,240,76.1a1.77,1.77,0,0,0-1.79,0,5.9,5.9,0,0,0-1.79,2.06c-.6,1-1.19,2.26-1.79,3.52s-1.19,2.52-1.79,3.52A6,6,0,0,1,231,87.27a1.76,1.76,0,0,1-1.79,0,8.42,8.42,0,0,1-1.8-1.44,7.92,7.92,0,0,0-1.79-1.45,1.76,1.76,0,0,0-1.79,0A5.89,5.89,0,0,0,222,86.44c-.6,1-1.19,2.26-1.79,3.52s-1.2,2.53-1.79,3.52a5.81,5.81,0,0,1-1.8,2.06,1.76,1.76,0,0,1-1.79,0,9,9,0,0,1-1.79-1.45,8.44,8.44,0,0,0-1.79-1.45,1.77,1.77,0,0,0-1.79,0,5.7,5.7,0,0,0-1.79,2.06,38.21,38.21,0,0,0-1.79,3.52c-.6,1.26-1.2,2.52-1.8,3.51a5.75,5.75,0,0,1-1.79,2.07,1.76,1.76,0,0,1-1.79,0,8.14,8.14,0,0,1-1.79-1.45,8.38,8.38,0,0,0-1.79-1.44,1.76,1.76,0,0,0-1.79,0,5.79,5.79,0,0,0-1.79,2.06c-.6,1-1.2,2.26-1.8,3.52s-1.19,2.53-1.79,3.52a5.7,5.7,0,0,1-1.79,2.06,1.77,1.77,0,0,1-1.79,0,8.77,8.77,0,0,1-1.79-1.45,8.7,8.7,0,0,0-1.79-1.45,1.76,1.76,0,0,0-1.79,0,5.72,5.72,0,0,0-1.8,2.06c-.59,1-1.19,2.25-1.79,3.52a39.28,39.28,0,0,1-1.79,3.51,5.85,5.85,0,0,1-1.79,2.07,1.77,1.77,0,0,1-1.79,0,7.92,7.92,0,0,1-1.79-1.45,9,9,0,0,0-1.79-1.45,1.78,1.78,0,0,0-1.8,0,5.9,5.9,0,0,0-1.79,2.06c-.59,1-1.19,2.26-1.79,3.52s-1.19,2.52-1.79,3.52a5.8,5.8,0,0,1-1.79,2.06,1.79,1.79,0,0,1-1.79,0,8.51,8.51,0,0,1-1.79-1.45,8.18,8.18,0,0,0-1.8-1.45,1.76,1.76,0,0,0-1.79,0,6,6,0,0,0-1.79,2.07c-.6,1-1.19,2.25-1.79,3.51s-1.19,2.53-1.79,3.52a5.81,5.81,0,0,1-1.79,2.06,1.77,1.77,0,0,1-1.79,0,8.48,8.48,0,0,1-1.8-1.45,8.51,8.51,0,0,0-1.79-1.45,1.77,1.77,0,0,0-1.79,0,5.8,5.8,0,0,0-1.79,2.06c-.6,1-1.19,2.26-1.79,3.52s-1.2,2.52-1.79,3.52a6,6,0,0,1-1.79,2.06,1.78,1.78,0,0,1-1.8,0,8.63,8.63,0,0,1-1.79-1.44,7.92,7.92,0,0,0-1.79-1.45,1.77,1.77,0,0,0-1.79,0,5.85,5.85,0,0,0-1.79,2.07,39.28,39.28,0,0,0-1.79,3.51c-.6,1.26-1.2,2.53-1.79,3.52a5.81,5.81,0,0,1-1.8,2.06,1.76,1.76,0,0,1-1.79,0,9,9,0,0,1-1.79-1.45,8.77,8.77,0,0,0-1.79-1.45,1.77,1.77,0,0,0-1.79,0,5.7,5.7,0,0,0-1.79,2.06c-.6,1-1.2,2.26-1.79,3.52s-1.2,2.52-1.8,3.51a5.75,5.75,0,0,1-1.79,2.07,1.76,1.76,0,0,1-1.79,0,8.14,8.14,0,0,1-1.79-1.45,8.38,8.38,0,0,0-1.79-1.44,1.76,1.76,0,0,0-1.79,0,5.79,5.79,0,0,0-1.79,2.06c-.6,1-1.2,2.26-1.8,3.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.62,59.55a1.76,1.76,0,0,0-1.79,0,5.81,5.81,0,0,0-1.8,2.06c-.59,1-1.19,2.26-1.79,3.52-.1.23-.21.45-.32.68l118.5,81.24c.11-.22.21-.45.32-.68.6-1.26,1.2-2.52,1.79-3.51a5.86,5.86,0,0,1,1.8-2.07,1.76,1.76,0,0,1,1.79,0,2.9,2.9,0,0,1,.33.2L269.07,59.83A3.68,3.68,0,0,0,268.62,59.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.29,67.83a1.76,1.76,0,0,0-1.79,0,5.7,5.7,0,0,0-1.79,2.06c-.6,1-1.2,2.26-1.8,3.52l-.32.68,118.5,81.24c.11-.22.22-.45.32-.68.6-1.26,1.2-2.52,1.8-3.51a5.75,5.75,0,0,1,1.79-2.07,1.76,1.76,0,0,1,1.79,0c.11,0,.22.12.34.19L254.74,68.11A3.68,3.68,0,0,0,254.29,67.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,76.11a1.77,1.77,0,0,0-1.79,0,5.8,5.8,0,0,0-1.79,2.06,38.21,38.21,0,0,0-1.79,3.52l-.33.67,118.5,81.25.33-.68c.59-1.26,1.19-2.52,1.79-3.52a5.79,5.79,0,0,1,1.79-2.06,1.77,1.77,0,0,1,1.79,0,2.9,2.9,0,0,1,.34.19L240.41,76.38Q240.19,76.23,240,76.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.63,84.39a1.77,1.77,0,0,0-1.79,0,5.71,5.71,0,0,0-1.79,2.06c-.6,1-1.19,2.25-1.79,3.52-.11.22-.22.45-.32.67l118.5,81.25c.1-.23.21-.45.32-.68.6-1.26,1.19-2.52,1.79-3.52a5.8,5.8,0,0,1,1.79-2.06,1.77,1.77,0,0,1,1.79,0,3.79,3.79,0,0,1,.34.2L226.08,84.66Q225.86,84.51,225.63,84.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.31,92.67a1.78,1.78,0,0,0-1.8,0,6,6,0,0,0-1.79,2.07c-.59,1-1.19,2.25-1.79,3.51-.11.23-.21.46-.32.68l118.5,81.25.32-.68c.6-1.26,1.19-2.53,1.79-3.52a5.9,5.9,0,0,1,1.79-2.06,1.77,1.77,0,0,1,1.79,0,3.79,3.79,0,0,1,.34.2L211.75,92.94A4.37,4.37,0,0,0,211.31,92.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,101a1.76,1.76,0,0,0-1.79,0,5.86,5.86,0,0,0-1.8,2.07c-.59,1-1.19,2.25-1.79,3.51-.1.23-.21.46-.32.68l118.5,81.25.32-.68c.6-1.26,1.2-2.53,1.79-3.52a5.81,5.81,0,0,1,1.8-2.06,1.76,1.76,0,0,1,1.79,0l.33.2L197.43,101.22A3.57,3.57,0,0,0,197,101Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.65,109.23a1.77,1.77,0,0,0-1.79,0,5.79,5.79,0,0,0-1.79,2.06c-.6,1-1.2,2.26-1.79,3.52l-.33.68,118.5,81.24c.11-.22.22-.45.32-.67.6-1.27,1.2-2.53,1.8-3.52a5.7,5.7,0,0,1,1.79-2.06,1.76,1.76,0,0,1,1.79,0l.34.2L183.1,109.5A2.68,2.68,0,0,0,182.65,109.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.32,117.5a1.79,1.79,0,0,0-1.79,0,5.8,5.8,0,0,0-1.79,2.06c-.6,1-1.2,2.26-1.79,3.52-.11.23-.22.45-.32.68L281.12,205l.33-.68a39.28,39.28,0,0,1,1.79-3.51,5.85,5.85,0,0,1,1.79-2.07,1.77,1.77,0,0,1,1.79,0,3,3,0,0,1,.34.2L168.77,117.78A3.68,3.68,0,0,0,168.32,117.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,125.78a1.77,1.77,0,0,0-1.79,0,5.8,5.8,0,0,0-1.79,2.06c-.6,1-1.19,2.26-1.79,3.52-.11.23-.22.45-.32.68l118.5,81.24.32-.68c.6-1.26,1.19-2.52,1.79-3.51A5.85,5.85,0,0,1,270.7,207a1.76,1.76,0,0,1,1.79,0,1.68,1.68,0,0,1,.34.2L154.44,126.06A3.68,3.68,0,0,0,154,125.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.67,134.06a1.78,1.78,0,0,0-1.8,0,5.9,5.9,0,0,0-1.79,2.06c-.59,1-1.19,2.26-1.79,3.52-.11.22-.21.45-.32.68l118.5,81.24.32-.68c.6-1.26,1.2-2.52,1.79-3.52a6,6,0,0,1,1.79-2.06,1.78,1.78,0,0,1,1.8,0,2.79,2.79,0,0,1,.33.19L140.11,134.34A4.54,4.54,0,0,0,139.67,134.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.34,142.34a1.76,1.76,0,0,0-1.79,0,5.81,5.81,0,0,0-1.8,2.06c-.59,1-1.19,2.25-1.79,3.52-.1.22-.21.45-.32.67l118.5,81.25c.11-.23.22-.45.32-.68.6-1.26,1.2-2.52,1.79-3.52a5.9,5.9,0,0,1,1.8-2.06,1.76,1.76,0,0,1,1.79,0,2.79,2.79,0,0,1,.33.19L125.79,142.61Q125.57,142.46,125.34,142.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,150.62a1.79,1.79,0,0,0-1.79,0,5.75,5.75,0,0,0-1.79,2.07,38.21,38.21,0,0,0-1.79,3.52l-.33.67,118.5,81.25.33-.68c.59-1.26,1.19-2.52,1.79-3.52a5.7,5.7,0,0,1,1.79-2.06,1.77,1.77,0,0,1,1.79,0l.34.2L111.46,150.89A3.57,3.57,0,0,0,111,150.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.68,158.9a1.77,1.77,0,0,0-1.79,0A5.85,5.85,0,0,0,93.1,161a39.28,39.28,0,0,0-1.79,3.51l-.32.68,118.49,81.25.33-.68c.59-1.26,1.19-2.53,1.79-3.52a5.8,5.8,0,0,1,1.79-2.06,1.77,1.77,0,0,1,1.79,0l.34.2L97.13,159.17A3.57,3.57,0,0,0,96.68,158.9Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Drawer--inject-4"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "283.99 292.58 283.99 320.94 293.56 326.46 316.53 313.2 316.53 311.36 283.99 292.58"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "283.99 292.58 283.99 316.97 291.39 321.24 312.48 309.02 283.99 292.58",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.99 292.58 283.99 316.97 291.39 321.24 312.48 309.02 283.99 292.58",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shelf--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "283.99 271.55 283.99 298.73 291.39 303 312.48 290.78 312.48 288 283.99 271.55",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.99 271.55 283.99 298.73 291.39 303 312.48 290.78 312.48 288 283.99 271.55",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.99 271.55 283.99 295.94 291.39 300.22 312.48 288 283.99 271.55",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.99 271.55 283.99 295.94 291.39 300.22 312.48 288 283.99 271.55",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Body--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "283.99 263.69 283.99 266.19 291.39 270.46 291.39 321.24 283.99 316.97 283.99 319.46 293.56 324.99 293.56 269.21 283.99 263.69",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.99 263.69 283.99 266.19 291.39 270.46 291.39 321.24 283.99 316.97 283.99 319.46 293.56 324.99 293.56 269.21 283.99 263.69",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "293.56 269.21 293.56 324.99 317.81 311 317.81 255.21 293.56 269.21"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "283.99 235.69 283.99 263.68 293.56 269.21 317.81 255.21 283.99 235.69",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M318.34,254.13a1,1,0,0,0-.6-.87L284,233.78v31.48l9.58,5.52,24.17-14a1,1,0,0,0,.6-.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,268.05a2.93,2.93,0,0,1-1.43.34v2.39L295,270l22.74-13.14,1.44-.82v-1.91l-1.44.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.99 233.78 283.99 263.35 293.56 268.88 319.18 254.09 283.99 233.78",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shovel--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-4",
    d: "M339,225.76h0a2.78,2.78,0,0,0-.74-1.58,25.68,25.68,0,0,0-5-3.9,17.83,17.83,0,0,0-5.2-2.07.86.86,0,0,0-1,.56,1.42,1.42,0,0,0-.13.47l-.52,4.54a16,16,0,0,0,1.78,8.91L330,236c-.05.49-.11,1.15-.19,1.87v0s-.07.66-.17,1.76c-.14,1.33-.25,2.47-.26,2.56v0c-1.16,11.76-4.35,43.91-5.19,52.42h0c0,.12-.28,2.81-.54,5.4L319,296.77h0l-1.47.5h0l-3.89,18.42c-.87,4.11-.54,6.59,1,11.16.94,2.41,2.56,5.4,3.48,6a3.73,3.73,0,0,0,.53.26h0c2,1.42,4.13,1.33,7.82-.24s4.52-2.95,5.22-4.29c.24-.58.48-1.22.7-1.94,1.92-6.28,2.85-18.12,2.85-18.12l-7.52-5.41c.17-1.74.41-4.13.58-5.84h0v-.18c.23-2.26,2.62-26.4,4.26-43l.09-.9q.14-1.41.27-2.73c.3-3,.56-5.68.76-7.71h0s0-.31.07-.71l.05-.5c0-.29.07-.63.1-1v-.12c.08-.76.17-1.6.24-2.36v-.12c0-.32.07-.63.1-.91l.72-.34c1.88-.88,3.15-3,3.48-5.81l.52-4.54A2,2,0,0,0,339,225.76Zm-2,4.24c-.26,2.29-1.3,4-2.83,4.75l-.25.11a.94.94,0,0,0-.1-.1,3.48,3.48,0,0,0-3.12-.31l-.08,0-1.34-2.6a13.26,13.26,0,0,1-1.45-7.27l.29-2.51a17.88,17.88,0,0,1,9.17,5.38Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shovel--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.58,309s-1.14,11.82-3.17,18.06a20.42,20.42,0,0,1-.74,1.92c-.72,1.34-1.57,2.7-5.29,4.2s-5.83,1.56-7.82.1-.9-4.76-3.21-5.93c-1.62-4.31-2.47-7.53-1.55-11.55L315,297.49l1.48-.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.5 297.02 315.02 297.49 331.1 309.51 332.58 309.04 316.5 297.02",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.1,309.51s-1.51,12.67-3.57,18.35h0a6,6,0,0,1-1.9,2.68c-3.1,2.47-8.43,3.92-10.6,2.5-.91-.59-2.48-3.61-3.37-6-1.5-4.59-1.79-7.08-.85-11.17L315,297.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.05,303l3.5,2.74c-.13,3.63-2.47,13.17-3.51,14.58s-2.16.45-2-.91S321.37,307.26,321.05,303Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.7,295.05a1.08,1.08,0,0,1,.75-.82,3.44,3.44,0,0,1,3.1.36,1.1,1.1,0,0,1,.54,1c0,.23-1.17,9.92-1.2,10.15a1.09,1.09,0,0,1-.75.82,3.45,3.45,0,0,1-3.1-.37,1.1,1.1,0,0,1-.54-1C320.53,305,321.67,295.28,321.7,295.05Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.45,294.23a1.08,1.08,0,0,0-.75.82,1.1,1.1,0,0,0,.54,1,3.45,3.45,0,0,0,3.1.37,1,1,0,0,0,.21-1.8A3.44,3.44,0,0,0,322.45,294.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.32,238.39a1.1,1.1,0,0,1,.75-.82,3.44,3.44,0,0,1,3.11.37,1.08,1.08,0,0,1,.54,1c0,.23-6.84,58.51-6.87,58.74a1.11,1.11,0,0,1-.75.82,3.47,3.47,0,0,1-3.11-.37,1.09,1.09,0,0,1-.53-1C321.48,296.9,328.3,238.62,328.32,238.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.07,237.57a1.1,1.1,0,0,0-.75.82,1.12,1.12,0,0,0,.54,1,3.47,3.47,0,0,0,3.11.37,1.11,1.11,0,0,0,.75-.82,1.08,1.08,0,0,0-.54-1A3.44,3.44,0,0,0,329.07,237.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.64,235.74a1.11,1.11,0,0,1,.75-.82,3.47,3.47,0,0,1,3.11.37,1.1,1.1,0,0,1,.54,1c0,.24-.8,6.73-.83,7a1.11,1.11,0,0,1-.75.82,3.5,3.5,0,0,1-3.11-.37,1.09,1.09,0,0,1-.53-1C327.84,242.47,328.61,236,328.64,235.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.5,235.29a1.1,1.1,0,0,1,.54,1c0,.24-.8,6.73-.83,7h0c-1.58,13.51-6.34,54.22-6.36,54.42h0c-.35,2.92-.94,7.89-1,8.06a1.09,1.09,0,0,1-.75.82,2.88,2.88,0,0,1-1,.19c2.95-25.17,6.62-56.58,8.41-71.86A2.93,2.93,0,0,1,332.5,235.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.39,234.92a1,1,0,0,0-.21,1.8,3.5,3.5,0,0,0,3.11.37,1,1,0,0,0,.21-1.8A3.47,3.47,0,0,0,329.39,234.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.27,224.18a16,16,0,0,0,1.62,8.94l1.77,3.6c.62,1.27,1.72,1.94,2.56,1.56l2.39-1.06c1.91-.86,3.21-2.95,3.59-5.76l.6-4.53a2,2,0,0,0,0-.55h0a2.74,2.74,0,0,0-.71-1.59,25.51,25.51,0,0,0-4.92-4,17.88,17.88,0,0,0-5.17-2.17.86.86,0,0,0-1,.54h0a1.71,1.71,0,0,0-.13.47Zm7.58,11.1-2.39,1.07c-.22.1-.51-.07-.68-.41l-1.76-3.6a13.17,13.17,0,0,1-1.33-7.29l.34-2.51a17.87,17.87,0,0,1,9.07,5.54l-.33,2.51C335.46,232.88,334.4,234.59,332.85,235.28Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pickaxe--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-4",
    d: "M370.25,299.39l-.3.08a3.07,3.07,0,0,1-2-.27,1,1,0,0,1-.58-.81c0-.21,0-8.93,0-9.13h0c0-8.14-.07-38-.08-46.3a1,1,0,0,1-.4-.76v-4.78l-.37-.21c-12.42-6.89-19.47-5.44-19.71-5.39h0a3.63,3.63,0,0,1,.29-.25c1.48-1.24,8.76-6.52,19.81-1.44v-.6a.86.86,0,0,1,.18-.52,1.47,1.47,0,0,1,.52-.45,3.12,3.12,0,0,1,1.22-.38,4.61,4.61,0,0,1,.91,0l.09,0h0a2,2,0,0,1,.35.06,1.06,1.06,0,0,1,.19.06l.1,0a2.71,2.71,0,0,1,.49.22,1.53,1.53,0,0,1,.21.14h0a1.3,1.3,0,0,1,.31.31l0,0a.76.76,0,0,1,.11.22.86.86,0,0,1,0,.27v3.62c14.21,10.72,15.82,23.26,15.82,23.26s-4.9-7.79-15.82-15.77v1.55a1,1,0,0,1-.4.76c0,3.85,0,12.94,0,22.39,0,5.82,0,11.77,0,16.73,0,6.81,0,9,0,9.06h0v7.26a1,1,0,0,1-.58.81A2.56,2.56,0,0,1,370.25,299.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pickaxe--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.64,237v-2.4l2.86-1.66-.38-.22c-13.9-8-22.61.39-22.61.39S351.57,230.29,364.64,237Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.25,238.52l.39.22c0-1.48,0-3,0-4.12l-.39-.22c-13.44-7.54-19.73-1.26-19.73-1.26S351.62,231.51,364.25,238.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.1,290.57a1,1,0,0,1,.58-.8,3.05,3.05,0,0,1,2.79,0,1,1,0,0,1,.58.8c0,.21,0,8.93,0,9.14a1,1,0,0,1-.58.81,3.13,3.13,0,0,1-2.8,0,1,1,0,0,1-.57-.81C365.11,299.5,365.1,290.78,365.1,290.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.68,289.77a.85.85,0,0,0,0,1.61,3.05,3.05,0,0,0,2.79,0,.85.85,0,0,0,0-1.61A3.05,3.05,0,0,0,365.68,289.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,242.32a1,1,0,0,1,.58-.8,3.05,3.05,0,0,1,2.79,0,1,1,0,0,1,.58.8c0,.21.1,49.92.1,50.13a1,1,0,0,1-.58.8,3.07,3.07,0,0,1-2.8,0,1,1,0,0,1-.58-.8C365.1,292.24,365,242.53,365,242.32Z",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.59,241.52a1,1,0,0,0-.58.8,1,1,0,0,0,.58.81,3.11,3.11,0,0,0,2.79,0,1,1,0,0,0,.58-.81,1,1,0,0,0-.58-.8A3.05,3.05,0,0,0,365.59,241.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.62,230.84a1.18,1.18,0,0,1,.69-1,3.75,3.75,0,0,1,3.36,0,1.18,1.18,0,0,1,.69,1v12.67a1.18,1.18,0,0,1-.69,1,3.75,3.75,0,0,1-3.36,0,1.18,1.18,0,0,1-.69-1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.31,229.87a1,1,0,0,0,0,1.94,3.69,3.69,0,0,0,3.36,0,1,1,0,0,0,0-1.94A3.75,3.75,0,0,0,365.31,229.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.67,229.87a1.59,1.59,0,0,1,.52.46,1,1,0,0,1,.13.25.82.82,0,0,1,0,.26v12.67a1,1,0,0,1-.4.76c0,9.47.1,48,.1,48.18h0c0,2.63,0,7.11,0,7.26a1,1,0,0,1-.58.81,2.57,2.57,0,0,1-.81.26c0-17.8-.11-56.2-.13-71.27A3.33,3.33,0,0,1,368.67,229.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.19,257.73s-1.66-13-16.57-23.82l-2.74,1.58.59,2.57A60.64,60.64,0,0,1,385.19,257.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.19,257.73s-3.91-11.81-19.31-22.24c0,1.36,0,2.8,0,4C379.27,248.29,385.19,257.73,385.19,257.73Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--hanging-flowerpot--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.68,288.42h-.08a.38.38,0,0,1-.29-.44l13.4-29.69a.38.38,0,0,1,.44-.29.36.36,0,0,1,.29.44l-13.39,29.69A.38.38,0,0,1,181.68,288.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.46,288.75a.36.36,0,0,1-.36-.3l-13.39-30a.37.37,0,1,1,.73-.15l13.39,30a.38.38,0,0,1-.29.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.11,292.39H182.9l2.5,10.42h0a5.07,5.07,0,0,0,2.78,3.45,15.08,15.08,0,0,0,13.63,0,5.41,5.41,0,0,0,2.87-3.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.16,299.54a10.3,10.3,0,0,0,1.45-1L207,293a9.78,9.78,0,0,1-2.45,1.95c-5.1,3-13.29,3-18.57.24l.62-2.49-.19-.26H182.9l2.5,10.42h0a5.07,5.07,0,0,0,2.78,3.45,15,15,0,0,0,9.91,1.33c-6,.45-10.17-2.19-10.79-4.62-.24-1-.68-3.11-.68-3.11C191.67,302.41,199.34,302.31,204.16,299.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.37,289.31a5.24,5.24,0,0,1-.81,1.88,9.06,9.06,0,0,1-3,2.7c-5.25,3-13.77,3-19,0a9.15,9.15,0,0,1-3-2.7,5.21,5.21,0,0,1-.8-1.88h0c-.47-2.28.81-4.66,3.84-6.41,5.26-3,13.78-3,19,0C207.55,284.65,208.84,287,208.37,289.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.56,291.19a9.06,9.06,0,0,1-3,2.7c-5.25,3-13.77,3-19,0a9.15,9.15,0,0,1-3-2.7,5.21,5.21,0,0,1-.8-1.88h0l.59,4.1c.28,1.65,1.51,3.26,3.7,4.52,5,2.89,13.13,2.89,18.13,0,2.17-1.24,3.4-2.83,3.69-4.46l0-.21.58-3.95A5.24,5.24,0,0,1,207.56,291.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.94,283.81a17.52,17.52,0,0,0-15.86,0c-2.48,1.44-3.55,3.37-3.23,5.24a6,6,0,0,0,3.23,3.92,17.52,17.52,0,0,0,15.86,0,6,6,0,0,0,3.22-3.92C206.49,287.18,205.42,285.25,202.94,283.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.59,290.78a7.55,7.55,0,0,0,2.49,2.19,17.52,17.52,0,0,0,15.86,0,7.5,7.5,0,0,0,2.48-2.19c0-1.52-1-3-3-4.18a16.29,16.29,0,0,0-14.74,0C185.64,287.76,184.63,289.27,184.59,290.78Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.44,276.5c-.16-4.81-2-12.29-3.71-15.31a24.6,24.6,0,0,1,5.48,14.23Z",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.44,276.5c-.16-4.81-2-12.29-3.71-15.31a24.6,24.6,0,0,1,5.48,14.23Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.67,286.88c.16-3.34,2.62-4.43,5.39-3.34,2,.77,4.82,3.7,5.71,8.36C207.89,289.5,201.51,281.39,197.67,286.88Z",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.82,288.49a2.75,2.75,0,0,1,3.23-2.48c2,.41,6.57,4,8.52,9.91-.35-4-1.64-7.38-4.29-9.59s-4.57-2.56-6.5-1.41C197.12,285.91,197.82,288.49,197.82,288.49Z",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.82,288.49a2.75,2.75,0,0,1,3.23-2.48c2,.41,6.57,4,8.52,9.91-.35-4-1.64-7.38-4.29-9.59s-4.57-2.56-6.5-1.41C197.12,285.91,197.82,288.49,197.82,288.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.3,290.11c-1.59-5.32-1.82-15.21-.29-20.56,2.17-7.56,6.66-10.87,10-11.67-3.17,1.33-6.53,6.17-7.47,10.91s-.4,21.32-.4,21.32Z",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.29,273.3c2.17-2.12,3.86-3.55,6.54-3.41s6.27,3.89,8.35,11.83c-2.15-5-4.93-9.48-9.38-10A7.18,7.18,0,0,0,200.29,273.3Z",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.29,273.3c2.17-2.12,3.86-3.55,6.54-3.41s6.27,3.89,8.35,11.83c-2.15-5-4.93-9.48-9.38-10A7.18,7.18,0,0,0,200.29,273.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.11,268.58a17.3,17.3,0,0,1,17.79,14.61l-2.39-.38s-2-6.26-5.41-9.51C183.05,270.42,180.78,269.27,176.11,268.58Z",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.48,281.7a16.88,16.88,0,0,0-5.18-12.16c-4.1-3.82-5.58-4.66-9.81-5.74a26.76,26.76,0,0,1,8.79,7.31,15.41,15.41,0,0,1,2.84,9.34C191.59,281.7,193.25,284.29,194.48,281.7Z",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.48,281.7a16.88,16.88,0,0,0-5.18-12.16c-4.1-3.82-5.58-4.66-9.81-5.74a26.76,26.76,0,0,1,8.79,7.31,15.41,15.41,0,0,1,2.84,9.34C191.59,281.7,193.25,284.29,194.48,281.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.3,283c-.53-3.42,1.31-9.55,3.46-12.54a17.16,17.16,0,0,1,10.69-7.08A19.33,19.33,0,0,0,198,275a26.05,26.05,0,0,0-.56,9.76Z",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.3,283c-.53-3.42,1.31-9.55,3.46-12.54a17.16,17.16,0,0,1,10.69-7.08A19.33,19.33,0,0,0,198,275a26.05,26.05,0,0,0-.56,9.76Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.61,284.92c.21-3,1.94-9.58,5.38-12.24a6.34,6.34,0,0,1,8.44.52,5.16,5.16,0,0,0-6.39.1c-1.81,1.5-3.65,6-4.58,10.24Z",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.61,284.92c.21-3,1.94-9.58,5.38-12.24a6.34,6.34,0,0,1,8.44.52,5.16,5.16,0,0,0-6.39.1c-1.81,1.5-3.65,6-4.58,10.24Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.76,290.11c-.58-3.2.44-9.85,5.7-13.52s8.9-2.7,10.28-2.28c-4.07-.28-8.16,2-10.66,4.79-1.74,1.95-3.37,5.14-3.47,10.43Z",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.83,290.38a3.13,3.13,0,0,0,1.93-.69c0-2.06.56-6.2,3.46-8.64s5.15-2,5.61-1c0-1.41-1.76-2.66-3.73-2.24C199.83,278.49,195.21,282.73,195.83,290.38Z",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.83,290.38a3.13,3.13,0,0,0,1.93-.69c0-2.06.56-6.2,3.46-8.64s5.15-2,5.61-1c0-1.41-1.76-2.66-3.73-2.24C199.83,278.49,195.21,282.73,195.83,290.38Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.39,278.43c1.79-1,3.32-1.81,5.31-.89.09-.05,1.22-.33,1.65.18,1.66,2,1.13,6.84-1.92,11.52,1.4-3.51,1.47-10-1.12-11A5.17,5.17,0,0,0,201.39,278.43Z",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.39,278.43c1.79-1,3.32-1.81,5.31-.89.09-.05,1.22-.33,1.65.18,1.66,2,1.13,6.84-1.92,11.52,1.4-3.51,1.47-10-1.12-11A5.17,5.17,0,0,0,201.39,278.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.7,277.54c.8.38,2.45,3.19,1.39,7.1,1-3,.63-5.8-1-7.18Z",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.7,277.54c.8.38,2.45,3.19,1.39,7.1,1-3,.63-5.8-1-7.18Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.31,289.42a2.75,2.75,0,0,0-3-2.73c-2,.25-6.86,3.48-9.27,9.21a16,16,0,0,1,4.92-9.43c2.3-2.07,5.17-2.93,7.29-1.58S192.31,289.42,192.31,289.42Z",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.31,289.42a2.75,2.75,0,0,0-3-2.73c-2,.25-6.86,3.48-9.27,9.21a16,16,0,0,1,4.92-9.43c2.3-2.07,5.17-2.93,7.29-1.58S192.31,289.42,192.31,289.42Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.51,282c-1.71-1.72-2.92-3.36-6.08-2.71s-5.32,4.09-6.18,8.72c.54-1.79,2.17-5.89,5.39-6.58S189.45,280.93,191.51,282Z",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.32,289.42c-.44-3-1.6-7.35-4.82-7.53s-6.77,1.86-8.25,6.08c.76-3.84,4-7.51,7.46-7.52s6.78.74,7.59,9.66Z",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.32,289.42c-.44-3-1.6-7.35-4.82-7.53s-6.77,1.86-8.25,6.08c.76-3.84,4-7.51,7.46-7.52s6.78.74,7.59,9.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.61,276.55a8.81,8.81,0,0,0-4.45-2.2c-1.1-.18-3.24-1-5.53,1.1s-4.7,7.11-3.85,10.59C176.15,282.35,181.11,272,189.61,276.55Z",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.61,276.55a8.81,8.81,0,0,0-4.45-2.2c-1.1-.18-3.24-1-5.53,1.1s-4.7,7.11-3.85,10.59C176.15,282.35,181.11,272,189.61,276.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.76,290.41c0-2.81-2-11.73-5.29-14-4.06-2.84-6.78-.42-6.78-.42a5.45,5.45,0,0,1,4.84.77c2.09,1.53,4.05,6,4.79,12.66A2.93,2.93,0,0,0,194.76,290.41Z",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.76,290.41c0-2.81-2-11.73-5.29-14-4.06-2.84-6.78-.42-6.78-.42a5.45,5.45,0,0,1,4.84.77c2.09,1.53,4.05,6,4.79,12.66A2.93,2.93,0,0,0,194.76,290.41Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.92,282a31.28,31.28,0,0,0,1.32,8.34,5.86,5.86,0,0,0,2,0c.61-1.08,0-8,1.2-8.15C196.48,281.77,193.35,280.62,192.92,282Z",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.92,282a31.28,31.28,0,0,0,1.32,8.34,5.86,5.86,0,0,0,2,0c.61-1.08,0-8,1.2-8.15C196.48,281.77,193.35,280.62,192.92,282Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.92,282c1-1,4.84.95,5.57,6.75,1-2.75.54-6.15-.43-7a1.74,1.74,0,0,0-2-.27S193.05,280.19,192.92,282Z",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.07,281.51c1.19.5,2.55,2.15,2.53,5,.1-1.44-.18-4-2.23-5.09A1.7,1.7,0,0,0,196.07,281.51Z",
    style: {
      fill: "#900000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.07,281.51c1.19.5,2.55,2.15,2.53,5,.1-1.44-.18-4-2.23-5.09A1.7,1.7,0,0,0,196.07,281.51Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.08,300.71a.38.38,0,0,1-.38-.38v-42a.38.38,0,1,1,.75,0v42A.38.38,0,0,1,195.08,300.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.08,258.73a3.35,3.35,0,1,1,3.34-3.34A3.35,3.35,0,0,1,195.08,258.73Zm0-5.94a2.6,2.6,0,1,0,2.59,2.6A2.61,2.61,0,0,0,195.08,252.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.45,236.79v15.63a.38.38,0,0,1-.75,0V236.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,300.7a19.53,19.53,0,0,1-9.44-2.21c-2.25-1.27-3.66-3-4-4.8a.37.37,0,0,1,.3-.43.37.37,0,0,1,.44.31c.27,1.59,1.54,3.11,3.59,4.26,5,2.83,13.14,2.83,18.14,0,2-1.14,3.28-2.64,3.57-4.21a.38.38,0,0,1,.75.14c-.33,1.8-1.73,3.48-3.95,4.73A19.53,19.53,0,0,1,195,300.7Z",
    style: {
      fill: "#ebebeb"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocks);
export default __webpack_public_path__ + "static/media/blocks.4ddc4c9efb924ee886850e9de6fca420.svg";
export { ForwardRef as ReactComponent };